export const ActionTypes = {
  TOGGLE_CATEGORY: 'TOGGLE_CATEGORY',
  REORDER_SUBCATEGORIES: 'REORDER_SUBCATEGORIES',
  REORDER_CATEGORIES: 'REORDER_CATEGORIES',
  ADD_CATEGORY: 'ADD_CATEGORY',
  UPDATE_CATEGORY: 'UPDATE_CATEGORY',
  DELETE_CATEGORY: 'DELETE_CATEGORY',
  TOGGLE_DIRECTORY: 'TOGGLE_DIRECTORY',
  INCREMENT_NEXT_TEMP_ID: 'INCREMENT_NEXT_TEMP_ID',
  REORDER_DIRECTORIES: 'REORDER_DIRECTORIES',
  SET_ROUNDS_DAYS_BEFORE_DATE: 'SET_ROUNDS_DAYS_BEFORE_DATE',
  SET_CHAT_MEMBER_MESSAGING_ENABLED: 'SET_CHAT_MEMBER_MESSAGING_ENABLED',
  SET_CHAT_RESTRICT_MINORS: 'SET_CHAT_RESTRICT_MINORS',
};

export const toggleCategory = (categoryId) => ({
  type: ActionTypes.TOGGLE_CATEGORY,
  payload: { categoryId },
});

export const reorderSubcategories = (categoryId, reorderedSubcategories) => ({
  type: ActionTypes.REORDER_SUBCATEGORIES,
  payload: { categoryId, reorderedSubcategories },
});

export const reorderCategories = (reorderedCategories) => ({
  type: ActionTypes.REORDER_CATEGORIES,
  payload: reorderedCategories,
});

export const addCategory = (category) => ({
  type: ActionTypes.ADD_CATEGORY,
  payload: category,
});

export const updateCategory = (updatedItem) => ({
  type: ActionTypes.UPDATE_CATEGORY,
  payload: updatedItem,
});

export const deleteCategory = (id) => ({
  type: ActionTypes.DELETE_CATEGORY,
  payload: id,
});

export const toggleDirectory = (id) => ({
  type: ActionTypes.TOGGLE_DIRECTORY,
  payload: id,
});

export const incrementNextTempId = () => ({
  type: ActionTypes.INCREMENT_NEXT_TEMP_ID,
});

export const reorderDirectories = (directories) => ({
  type: ActionTypes.REORDER_DIRECTORIES,
  payload: directories,
});

export const setRoundsDaysBeforeDate = (days) => ({
  type: ActionTypes.SET_ROUNDS_DAYS_BEFORE_DATE,
  payload: days,
});

export const setChatMemberMessagingEnabled = (enabled) => ({
  type: ActionTypes.SET_CHAT_MEMBER_MESSAGING_ENABLED,
  payload: enabled,
});

export const setChatRestrictMinors = (restricted) => ({
  type: ActionTypes.SET_CHAT_RESTRICT_MINORS,
  payload: restricted,
});
